import * as Combobox from '@givebutter/primitives/combobox';

const PaymentStatusOptions = () => (
    <>
        <Combobox.Item value="succeeded">
            <Combobox.CheckboxIndicator />
            <Combobox.ItemText>Succeeded</Combobox.ItemText>
        </Combobox.Item>
        <Combobox.Item value="authorized">
            <Combobox.CheckboxIndicator />
            <Combobox.ItemText>Authorized</Combobox.ItemText>
        </Combobox.Item>
        <Combobox.Item value="disputed">
            <Combobox.CheckboxIndicator />
            <Combobox.ItemText>Disputed</Combobox.ItemText>
        </Combobox.Item>
        <Combobox.Item value="cancelled">
            <Combobox.CheckboxIndicator />
            <Combobox.ItemText>Cancelled</Combobox.ItemText>
        </Combobox.Item>
        <Combobox.Item value="pending">
            <Combobox.CheckboxIndicator />
            <Combobox.ItemText>Pending</Combobox.ItemText>
        </Combobox.Item>
        <Combobox.Item value="refunded">
            <Combobox.CheckboxIndicator />
            <Combobox.ItemText>Refunded</Combobox.ItemText>
        </Combobox.Item>
    </>
);

export { PaymentStatusOptions };
